<template>
    <div class="edit-table">
        <div class="form-item">
            <label>{{ $t("tables.tableName") }}</label>
            <a-input v-model="form.name" />
        </div>
        <div class="form-item">
            <label>{{ $t("tables.description") }}</label>
            <a-textarea v-model="form.description" />
        </div>
        <div class="form-item">
            <a-button type="primary" @click="handleSubmit">{{ $t("message.save") }}</a-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditTable",
    props: {
        table: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            form: {
                name: "",
                description: "",
            },
        };
    },
    methods: {
        handleSubmit() {
            this.$emit("update", this.form);
        },
    },
    watch: {
        table: {
            handler(newTable) {
                this.form.name = newTable.name;
                this.form.description = newTable.description;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>

<style scoped>
.form-item {
    margin-bottom: 16px;
}

label {
    display: block;
    margin-bottom: 8px;
}
</style>
